import { render } from "./ClientLogo.html?vue&type=template&id=2c18ec6e&external"
import script from "./ClientLogo.js?vue&type=script&lang=js&external"
export * from "./ClientLogo.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__